import DOMPurify from "dompurify";

export const inlineTags = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "ul",
  "ol",
  "li",
  "blockquote",
  "strong",
  "span",
  "em",
  "u",
  "s",
  "a",
  "i",
  "b",
  "q",
];

export const selfClosingTags = ["br", "hr", "link"];
export const containerTags = [
  "ul",
  "ol",
  "article",
  "section",
  "nav",
  "header",
  "footer",
  "main",
  "aside",
];

export const sanitizeTagsHTML = (html: string) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...inlineTags, ...selfClosingTags],
    ALLOWED_ATTR: ["href", "title"],
  });
};
